import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { ErpService } from 'src/app/services/erp.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Multilingual } from 'src/app/services/multilingual';
@Component({
  selector: 'app-erp-production-order',
  templateUrl: './erp-production-order.component.html',
  styleUrls: ['./erp-production-order.component.scss'],
})
export class ErpProductionOrderComponent implements OnInit {
  @ViewChild('podyField')
  private podyField!: TemplateRef<any>;
  @ViewChild('operation')
  private operation!: TemplateRef<any>;
  @ViewChild('bom')
  private bom!: TemplateRef<any>;
  breadcrumList: any;
  moduleId: any;
  pageId: any;
  permisson: any;
  IsAccess: any;
  IsWrite: any;
  filteredGroups: any;
  GroupList: any;
  productionPlanningForm: FormGroup;
  value: string;
  deparmentList: any;
  deparmentFiltList: any;
  PlantList: any;
  filteredPlants: any;
  isrowselected: Boolean = false;

  rowData: any = [];
  columnDefs: any = [
    { headerName: ' Company', field: 'Company', headerValueGetter: this.localizeHeader.bind(this)},
    { headerName: ' Item Code', field: 'ItemCode', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: ' Is Processs', field: 'IsProcesss', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: ' Item Desc', field: 'ItemDesc', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: ' Message', field: 'Message', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: ' PO', field: 'PO', headerValueGetter: this.localizeHeader.bind(this) },
    {
      headerName: ' Planned End Date',
      field: 'PlannedEndDate',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
    {
      headerName: ' Planned Start Date',
      field: 'PlannedStartDate',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
    { headerName: ' Plant Id', field: 'PlantId', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: ' Priority', field: 'Priority', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: ' Target', field: 'Target', headerValueGetter: this.localizeHeader.bind(this) },
    {
      headerName: 'Created On',
      field: ' CreatedOn',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
  ];
  bomData: any = [];
  bomDefs: any = [
    {
      headerName: 'Item',
      field: 'Item',
      headerValueGetter: this.localizeHeader.bind(this)
    },
    {
      headerName: 'Item Desc',
      field: 'ItemDesc',
      headerValueGetter: this.localizeHeader.bind(this)
    },
    { headerName: 'Estimated Qty', field: 'EstimatedQty', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Is Processed', field: 'IsProcessed', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Message', field: 'Message', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Net Qty', field: 'NetQty', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Operation', field: 'Operation', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Position', field: 'Position', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'UoM', field: 'UoM', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Ware house', field: 'Warehouse', headerValueGetter: this.localizeHeader.bind(this) },
    {
      headerName: 'CreatedOn',
      field: 'CreatedOn',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
  ];
  poddyData: any = [];
  podyDefs = [
    { headerName: 'IsProcessed', field: 'IsProcessed', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Key', field: 'Key', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Message', field: 'Message', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Value', field: 'Value', headerValueGetter: this.localizeHeader.bind(this) },
    {
      headerName: 'CreatedOn',
      field: 'CreatedOn',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
  ];
  operationData: any = [];
  operationDefs: any = [
    { headerName: 'Prod Code', field: 'ProdCode', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Prod Desc', field: 'ProdDesc', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Is Process', field: 'IsProcess', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Machine', field: 'Machine', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Message', field: 'Message', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Oper Name', field: 'OperName', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Oper No', field: 'OperNo', headerValueGetter: this.localizeHeader.bind(this) },

    { headerName: 'Remarks', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Target', field: 'Target', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'Target Speed', field: 'TargetSpeed', headerValueGetter: this.localizeHeader.bind(this) },
    { headerName: 'UoM', field: 'UoM', headerValueGetter: this.localizeHeader.bind(this) },
    {
      headerName: 'Created On',
      field: 'CreatedOn',
      valueFormatter: function (params: any) {
        return params.value !== null
          ? moment(params.value).format('MM/DD/YYYY')
          : '';
      },
      headerValueGetter: this.localizeHeader.bind(this)
    },
  ];
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    defaultColDef: {
      rowHeight: 45,
      rowStyle: {
        'border-bottom': 'white 10px solid',
        'border-top': 'white 10px solid',
        'max-height': '50px',
      },
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  rawMaterialData: any;
  rawMaterialItemForm: FormGroup;
  slectedRMTypeID: number;

  editType: boolean = false;
  eidtItem: boolean = false;
  selectedRMItemID: any;
  formDirective: any;
  file: any = [];
  excelFileRaw: any = [];
  exportData: any;
  readyToUpload: boolean = false;
  excelFile: any = [];
  selectedRows: any;
  rowSelection: string;
  langObj: any = {};
  languageDir: string;
  lang: any;

  constructor(
    private toaster: ToastrService,
    public router: Router,
    private userService: UserManagementService,
    private enterpriseGroupService: EnterPriseGroupService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private productivityservice: ProductivityService,
    private fb: FormBuilder,
    private ErpService: ErpService,
    public translate: TranslateService,
    public translater: TranslaterService
  ) {
    this.rowSelection = 'single';
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();});
  }

  ngOnInit(): void {
    this.productionPlanningForm = this.fb.group({
      group: ['', Validators.required],
      plant: ['', Validators.required],
    });

    this.getGroup();
    this.GetBreadcrumList();
    this.GetMenuAccess();
  }
  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    this.userService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId =
          this.breadcrumList && this.breadcrumList.length
            ? this.breadcrumList[0].id
            : '';
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        this.getLangWords();
        this.lang = new Multilingual(this.translater,this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value:string){
    let val;
    if(this.langObj && this.langObj[value]){
      val = this.langObj[value];
    }
    return val?val:value;
 }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if(this.langObj){
        this.gridApi.refreshHeader();
      }
    });
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }
  getGroup(): void {
    const key = {
      UserId: JSON.parse(localStorage.user).UserId,
    };
    const id = {
      value: 0,
    };
    this.productivityservice.getGroupData(key).subscribe(
      (data: any) => {
        this.GroupList = data.lstEG;
        if (this.GroupList && this.GroupList.length) {
          this.productionPlanningForm.controls.group.patchValue(
            this.GroupList[0].EG_Id
          );
        }
        this.filteredGroups = this.GroupList.slice();
        this.getPlants();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }
  getPlants() {
    const key = {
      EG_ID: this.productionPlanningForm.value.group,
      userId: JSON.parse(localStorage.user).UserId,
    };

    this.productivityservice.getPlantsData(key).subscribe(
      (data: any) => {
        this.PlantList = data.lstPlant;
        this.productionPlanningForm.controls.plant.patchValue(
          this.PlantList[0].PT_Id
        );
        this.filteredPlants = this.PlantList.slice();
        this.filterData();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  excelExport() {
    this.gridApi.exportDataAsExcel();
  }

  csvExport() {
    this.gridApi.exportDataAsCsv();
  }

  filterData() {
    const data = {
      PlantId: this.productionPlanningForm.value.plant,
    };

    this.ErpService.getProductDetails(data).subscribe(
      (res: any) => {
        if (res?.DTRes?.length) {
          this.rowData = res.DTRes;

          this.rowData.map((res: any) => {
            res.IsWrite = this.IsWrite;
          });
        } else this.rowData = [];
        if (res?.HasError) this.toaster.error(res.ErrorMessage, 'Error');
      },

      (err: any) => {
        this.toaster.error(err, 'Error');
      }
    );
  }

  operationPopup() {
    if (this.isrowselected) {
      const data = {
        PID: this.selectedRows[0].PID,
      };
      this.ErpService.GetOperation(data).subscribe(
        (res: any) => {
          if (res?.DTRes?.length) {
            this.operationData = res.DTRes;
            let dialogRef = this.dialog.open(this.operation, {
              width: '80%',
              height: '80%',
            });
          } else {
            this.toaster.warning('No Data Found', 'warning');
          }
          if (res?.HasError) this.toaster.error(res?.Status, 'Error');
        },

        (err: any) => {
          this.toaster.error(err, 'Error');
        }
      );
    } else {
      this.toaster.warning('Select a Row', 'Warning');
      return;
    }
  }
  BOMPopup() {
    if (this.isrowselected) {
      const data = {
        PID: this.selectedRows[0].PID,
      };
      this.ErpService.GetBOM(data).subscribe(
        (res: any) => {
          if (res?.DTRes?.length) {
            this.bomData = res.DTRes;
            let dialogRef = this.dialog.open(this.bom, {
              width: '80%',
              height: '80%',
            });
          } else {
            this.toaster.warning('No Data Found', 'warning');
          }
          if (res?.HasError) this.toaster.error(res?.Status, 'Error');
        },

        (err: any) => {
          this.toaster.error(err, 'Error');
        }
      );
    } else {
      this.toaster.warning('Select a Row', 'Warning');
      return;
    }
  }
  podyPopup() {
    if (this.isrowselected) {
      const data = {
        PID: this.selectedRows[0].PID,
      };
      this.ErpService.getproductionPODyFields(data).subscribe(
        (res: any) => {
          if (res?.DTRes?.length) {
            this.poddyData = res.DTRes;
            let dialogRef = this.dialog.open(this.podyField, {
              width: '80%',
              height: '80%',
            });
          } else {
            this.toaster.warning('No Data Found', 'warning');
          }
          if (res?.HasError) this.toaster.error(res?.Status, 'Error');
        },

        (err: any) => {
          this.toaster.error(err, 'Error');
        }
      );
    } else {
      this.toaster.warning('Select a Row', 'Warning');
      return;
    }
  }
  onSelectionChanged() {
    this.selectedRows = this.gridApi.getSelectedRows();
    this.selectedRows.length === 1 ? this.selectedRows[0] : '';
    this.isrowselected = true;
  }
}
